import React, { useState ,useContext} from "react";
import "./companyProfile.css";
import strings from "../../utils/property-file/companyProfile.json";
import { useForm, Controller } from "react-hook-form";
import api from "../../services/api";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import constants from "../../utils/constants";
import Autocomplete from "react-google-autocomplete";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import Geocode from "react-geocode";
import SpinnerButtonMedium from "../button/SpinnerButtonMedium";
import Select from 'react-select'
import appStyles from "../../utils/appStyles";
import bytesToMB from "../../utils/commonFunction/bytesToMb";
import { FetchedCompanyLogoContext } from "../fetchedCompanyLogo";
import HourHiveLogo from "../../Asset/Images/logoImage.png"

export default function CompanyProfile() {
  const nav = useNavigate();
  const [editingDetails, setEditingDetails] = useState(false);
  const [fetchingDetails, setFetchingDetails] = useState(true);
  const [companyInfo, setCompanyInfo] = useState([]);
  const [companySize, setCompanySize] = useState("");
  const [companyType, setCompanyType] = useState("");
  const [companyAddress, setAddress] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [empList, setEmpList] = useState();
  const [commonApprover, setCommonApprover] = useState(null);
  const [sickLeaveCount , setSickLeaveCount] = useState("");
  const [earnLeaveCount , setEarnLeaveCount] = useState("");
  const [approvers, setApprovers] = useState(null);
  const [logoCompany , setNewLogoCompany] = useState();
  const [logoUploadErrorClass , setLogoUploadErrorClass] = useState("disabled");
  const [logoFile , setNewLogoFile] = useState();
  const { companyLogo, setCompanyLogo } = useContext(FetchedCompanyLogoContext);

  useEffect(()=>{
    setEarnLeaveCount(companyInfo.length>0  ? (companyInfo[0].earnLeaveCount || companyInfo[0].earnLeaveCount==0 ? companyInfo[0].earnLeaveCount :null) : null)
    setSickLeaveCount(companyInfo.length>0 ? ( companyInfo[0].sickLeaveCount || companyInfo[0].sickLeaveCount==0 ?  companyInfo[0].sickLeaveCount :null)  :null)
  },[companyInfo ])
  
  useEffect(()=>{
    setEarnLeaveCount(earnLeaveCount)
    setSickLeaveCount(sickLeaveCount)
  },[sickLeaveCount ,earnLeaveCount])

  function setCompany(incomingData) {
    setAddress(incomingData.address);
    let arr = [{ label: incomingData.companySize, value: incomingData.companySize }];
    setCompanySize(arr)
    let arr2 = [{ label: incomingData.companyType, value: incomingData.companyType }];
    setCompanyType(arr2)
    setApprovers(incomingData.approvers);
    setCommonApprover(incomingData.commonApprover);
    setNewLogoCompany(incomingData.companyLogo);
    setCompanyLogo(incomingData.companyLogo ? incomingData.companyLogo :HourHiveLogo);
  }

  function Approvers(e) {
    let approverArr = [];
    e.map((val) => {
      let currentModule = val.value;
      approverArr.push(currentModule);
    });
    setApprovers(approverArr);
  }
  function CommApprovers(e) {
    let approverArr = [e];
    setCommonApprover(approverArr)
  }

  const gettingCompanyDetails = async () => {
    try {
      const response = await api.getCompanyDetails()
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setCompany(data ? data.body[0] : data);
          setCompanyInfo(data ? data.body : data);
          setFetchingDetails(false);
        }
        else {
          toast.error(data.body, { toastId: "error6" });
        }
      }
      setFetchingDetails(false)
    }
    catch (error) {
      setFetchingDetails(false)
    }
  }

  const getApproversDetails = async () => {
    try {
      const response = await api.getApprovers();
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setEmpList(data.body);
        }
        else {
          setEmpList();
        }
      }
    }
    catch (error) {
      setEmpList();
    }
  }

  async function getLatLngFromAddress(address) {
    try {
      if (address) {
        Geocode.setApiKey(constants.apiName.apiKey);
        const response = await Geocode.fromAddress(address)
        if (response) {
          const lat = response.results[0].geometry.location.lat;
          const lng = response.results[0].geometry.location.lng;
          return { lat, lng }
        } else {
          return false;
        }
      }
    } catch (e) {
      return false
    }
  }

  const companyGeo = async () => {
    const { lat, lng } = await getLatLngFromAddress(companyAddress);
    setLongitude(lng)
    setLatitude(lat);
  }
  useEffect(() => {
    companyGeo();
  }, [companyAddress]);

  const editCompanyDetails = async () => {
    try {
      if (earnLeaveCount==="" || earnLeaveCount===null  || earnLeaveCount > 50) {
        toast.error(strings.earnedLeaveError ,{toastId : "error6"});
        return;
      }
      
      if (sickLeaveCount==="" || sickLeaveCount===null  || sickLeaveCount > 50) {
        toast.error(strings.sickLeaveError ,{toastId : "error6"});
        return;
      }
      setEditingDetails(true);
      await uploadLogo();
      let commonApproverArray = [];
      if (commonApprover.length>0 && commonApprover[0]._id) {
          commonApproverArray.push(commonApprover[0]._id);
      } else if (commonApprover.length>0 && commonApprover[0].value) {
          commonApproverArray.push(commonApprover[0].value);
      } else {
          commonApproverArray.push(null);
      }
      const body = {
        companyType: companyType && companyType[0].value != undefined ? companyType[0].value : "",
        companySize: companySize && companySize[0].value != undefined ? companySize[0].value : "",
        address: companyAddress,
        latitude: latitude ? latitude.toString() : "",
        longitude: longitude ? longitude.toString() : "",
        approvers: approvers ? approvers : "",
        commonApprover:  commonApproverArray,
        earnLeaveCount : earnLeaveCount || earnLeaveCount==0 ? parseInt(earnLeaveCount) : null,
        sickLeaveCount : sickLeaveCount || sickLeaveCount==0 ? parseInt(sickLeaveCount) : null
      }
      const response = await api.editCompany(body);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          toast.success(data ? data.body : data, { toastId: "error13" })
          gettingCompanyDetails();
          setEditingDetails(false);
        }
        else {
          toast.error(data ? data.body : data, { toastId: "error6" })
        }
      }
      else {
        toast.error(strings.errorMessage, { toastId: "error6" })
      }
      setEditingDetails(false);
    }
    catch (error) {
      setEditingDetails(false);
      nav(constants.navigationLink.serverDown);
    }
  }

  useEffect(() => {
    gettingCompanyDetails();
    getApproversDetails();
  }, [])

  const {
    register,
    control,
    formState: { errors },
  } = useForm();

  function companySizeHandler(e) {
    let arr = []
    let obj = {
      label: e.label,
      value: e.value
    }
    arr.push(obj)
    setCompanySize(arr)
  }

  function companyTypeHandler(e) {
    let companyTypeArr = []
    let obj = {
      label: e.label,
      value: e.value
    }
    companyTypeArr.push(obj)
    setCompanyType(companyTypeArr)
  }

  function handleLogoUpload(event){
    const newLogoFile=event.target.files[0];
    setNewLogoFile(newLogoFile);
    const newLogoSize = bytesToMB(newLogoFile.size);
    const newLogoType= newLogoFile.type;
    if(newLogoSize <=10 && (newLogoType === strings.pngLabel || newLogoType===strings.jpegLabel || newLogoFile=== strings.jpgLabel)) {
      setLogoUploadErrorClass("disabled")
      setNewLogoCompany(URL.createObjectURL(newLogoFile));
    }
    else {
      setLogoUploadErrorClass("logo-upload-error")
      setNewLogoCompany(companyLogo ? companyLogo : "");
    }
  }

  const uploadLogo = async () =>{
    try{
      if(logoFile)
      {
      await api.updateCompanyLogo(logoFile);
      }
      else
      {
        return false;
      }
    }
    catch(error)
    {
      toast.error(strings.somethingWentWrongLabel ,{toastId : "error6"})
    }
  }

  const handleInput = (e) => {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
    }
  };

  return (
    <>
      {fetchingDetails ? (<div className="loader-company-details text-light"><Spinner /></div>) :
        (companyInfo ? (companyInfo.map((key ,index) => {
          return (
            <div className="mx-auto all-info" key={index}>
              <div>
                <div className="all-fields-company  company">
                  
                  <div className="input-fields-data">
                    <h3 className="company-profile mb-4">
                      {strings.label_profile}
                    </h3>
                    <div className="all-about-company">
                      <div className="main-container-logo-upload">
                      <label htmlFor="company-logo-upload" >
                      <div className="company-logo-details">
                      
                      <input type="file" className="d-none" id="company-logo-upload" accept="image/png ,image/jpeg , image/jpg" onChange={(event)=>{
                        handleLogoUpload(event);
                      }}/>
                      {logoCompany ? <img src={logoCompany} className="company-logo-image" alt="logo" /> :
                       (<i className="ri-building-4-line logo-icon-company-profile"></i>
                    )
                      }
                        <i className="ri-camera-line camera-icon-company-profile"></i>
                      </div>
                    </label>
                    <div className={logoUploadErrorClass}>
                    <i className="ri-error-warning-line error-icon-update-logo"></i>
                        {strings.fileNotSupported}
                      </div>
                      </div>
                      <div className="form-floating gap-input ">
                        <input
                          {...register("compName", {
                          })}
                          type="text"
                          className={
                            errors.compName
                              ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                              : "form-control validateEmail email-input add-employee-input-text"
                          }
                          placeholder=" "
                          autoComplete="off"
                          value={key.name}
                        />
                        <label
                          htmlFor="floating-input"
                          className="company-profile-labels"
                        >
                          {strings.Company_Name}
                        </label>
                        <div className="form-validation">
                          <small>
                            {errors.compName && (
                              <span>
                                <strong>&#9432;;</strong>
                                {errors.compName.message}
                              </span>
                            )}
                          </small>
                        </div>
                      </div>
                      <div className="form-floating gap-input ">
                        <input
                          {...register("compEmail", {
                          })}
                          type="text"
                          className={
                            errors.compEmail
                              ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                              : "form-control validateEmail email-input add-employee-input-text"
                          }
                          placeholder=" "
                          autoComplete="off"
                          value={key.email}
                        />
                        <label
                          htmlFor="floating-input"
                          className="company-profile-labels"
                        >
                          {strings.Label_Email_Address}
                        </label>
                        <div className="form-validation">
                          <small>
                            {errors.compEmail && (
                              <span>
                                <strong>&#9432;;</strong>
                                {errors.compEmail.message}
                              </span>
                            )}
                          </small>
                        </div>
                      </div>
                      <div className="form-floating gap-input ">
                        <div>
                          <label className="company-profile-labels2 mb-2">
                            {strings.Company_Type}
                          </label>

                          <Select
                            value={companyType[0]}
                            options={constants.companyTypeList}
                            onChange={companyTypeHandler}
                            styles={appStyles.companyProfileDropdown}
                            className="react-select-company-profile"
                          />
                          <div className="form-validation">
                            <small>
                              {errors.comType && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {strings.empTypeValidation}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                      </div>
                      <div className="address-field">
                        <label htmlFor="floating-input" className="company-profile-labels2 mb-2">
                          {strings.Address}
                        </label>
                        <Controller
                          name="companyAddress"
                          rules={{ required: true }}
                          control={control}
                          defaultValue={companyAddress ? companyAddress : ''}
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              className={errors.companyAddress ? "company-address-input-field error" : "company-address-input-field"}
                              placeholder={strings.companyAddressHeading}
                              apiKey={constants.apiName.apiKey}
                              value={companyAddress}
                              options={{
                                types: ["geocode", "establishment"]
                              }}
                              onChange={(e) => {
                                setAddress(e.target.value)
                                field.onChange(e.target.value);
                                companyGeo(companyAddress);
                              }}
                              onPlaceSelected={(place) => {
                                field.onChange(place.formatted_address);
                                setAddress(place.formatted_address)
                              }}
                            />
                          )}
                        />
                        <div className={errors.companyAddress ? "form-validation" : "display-none"}>
                          {errors.companyAddress && (
                            <span>
                              <strong>&#9432;</strong> {strings.companyAddressValidation}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="form-floating gap-input ">
                        <div>
                          <label className="company-profile-labels2 mb-2">
                            {strings.Company_Size}
                          </label>
                          <Select
                            value={companySize[0]}
                            options={constants.companySizeList}
                            onChange={companySizeHandler}
                            styles={appStyles.companyProfileDropdown}
                            className="react-select-company-profile"
                          />
                          <div className="form-validation">
                            <small>
                              {errors.comType && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {strings.empTypeValidation}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                      </div>
                      <div className="common-approver mb-3">
                        <label className="company-profile-labels2">{strings.commonApprover}</label>
                        <Select
                          defaultValue={commonApprover ? commonApprover.map((key) => ({
                            value: key._id,
                            label: key.name
                          })) : ""}
                          options={empList}
                          placeholder="Select.."
                          onChange={CommApprovers}
                          styles={appStyles.companyProfileDropdown}
                          className="react-select-company-profile"
                        />
                      </div>
                      <div className="common-approver">
                        <label className="company-profile-labels2 mb-2">{strings.approver}</label>
                        <Select defaultValue={approvers ? approvers.map((key) => ({
                          value: key._id,
                          label: key.name
                        })) : ""}
                          options={empList}
                          className="multi-select text-white react-select-company-profile"
                          placeholder="Select approvers"
                          styles={appStyles.companyProfileDropdown}
                          onChange={Approvers}
                          isMulti
                        />
                      </div>
                      <div className="common-approver mt-3">
                        <label className="company-profile-labels2 mb-2">{strings.earnLeave}</label>
                        <input type="number" className="d-block leave-input-box" placeholder="Enter earn leave *" value={earnLeaveCount} onChange={((e)=>{
                          if(e.keyCode === 38 || e.keyCode === 40) {
                            return;
                          }
                          setEarnLeaveCount(e.target.value)
                        })} onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} maxLength="2" onInput={handleInput} />

                      </div>
                      <div className="common-approver mt-3">
                        <label className="company-profile-labels2 mb-2">{strings.sickLeave}</label>
                        <input type="number" className="d-block leave-input-box" onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} placeholder="Enter sick leave *" value={sickLeaveCount} onChange={((e)=>{
                          setSickLeaveCount(e.target.value)
                        })}   maxLength="2" onInput={handleInput} />
                      </div>
                      <div className="mt-3">
                      <div className="button-container">
                        <button
                          type="reset"
                          className="btn btn-secondary discard-btn me-3"
                          onClick={(() => {
                            gettingCompanyDetails();
                          })}
                          disabled={companyAddress === key.address &&
                            companySize && companySize[0].value === key.companySize &&
                            companyType && companyType[0].value === key.companyType &&
                            commonApprover === key.commonApprover &&
                            approvers === key.approvers &&
                            logoCompany ===key.companyLogo &&
                            sickLeaveCount == key.sickLeaveCount &&
                            earnLeaveCount == key.earnLeaveCount
                          }
                        >
                          {strings.discard}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary save-btn"
                          onClick={() => {
                            editCompanyDetails();
                          }}

                          disabled={companyAddress === key.address &&
                            companySize && companySize[0].value === key.companySize &&
                            companyType && companyType[0].value === key.companyType &&
                            commonApprover === key.commonApprover &&
                            approvers === key.approvers &&
                            logoCompany === key.companyLogo &&
                            sickLeaveCount == key.sickLeaveCount &&
                            earnLeaveCount == key.earnLeaveCount
                          }
                        >
                          {editingDetails ? <SpinnerButtonMedium /> : strings.saveChange}
                        </button>
                      </div>
                    </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          )
        })) : "")}
    </>
  );
}